import { configureStore } from '@reduxjs/toolkit';
import network from './network/slice';
import whole from './whole/slice';
import person from './person/slice';
import booking from './booking/slice';
import popup from './popup/slice';

const store = configureStore({
  reducer: { network, whole, person, booking, popup },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({ serializableCheck: false });
  },
});

export default store;
